// @flow
import * as React from 'react';
import { Switch, Route } from 'react-router-dom';
import asyncComponent from 'common/helpers/asyncComponent';
import SplashScreen from 'common/modules/ui/components/SplashScreen';
import PrivateRoute from '../modules/authentication/PrivateRoute';
import ForgotPasswordPage from '../modules/authentication/FolloForgotPasswordPage';
import ResetPasswordPage from '../modules/authentication/FolloResetPasswordPage';
import DefaultRouteRedirect from '../modules/authorization/DefaultRouteRedirect';
import PropositionDetailsPage from '../modules/propositions/PropositionDetailPage';
import PropositionPrintingPage from '../modules/propositions/PropositionPrintingPage';
import withSalesPromotionBanners from '../modules/promotions/withSalesPromotionBanners';
import ConfirmEmailPage from '../modules/userProfile/ConfirmEmailPage';
import CampaignPrintingPage from '../modules/campaign/CampaignPrintingPage';
import SignUpPage from '../modules/signup/SignUpPage';
import AccessPage from '../modules/signup/AccessPage';
import TutorialPage from '../modules/tutorials/TutorialPage';
import PrivateRouteWithCampaignAccess from '../modules/authentication/PrivateRouteWithCampaignAccess';
import { isDevFlagEnabled } from '../../common/components/DevFlag';

const LoginPageComponent = asyncComponent(() =>
  import('../modules/authentication/AdvertisersLoginPage.js'),
  <SplashScreen />,
);

const AcceptInvitationPageComponent = asyncComponent(() =>
  import('../modules/registration/AcceptInvitationPage'),
  <SplashScreen />,
);
const DashboardPageComponent = asyncComponent(() =>
  import('../modules/dashboard/DashboardPage'),
  <SplashScreen />,
);
const ProposedCampaignsPageComponent = asyncComponent(() =>
  import('../modules/propositions/ProposedPage'),
  <SplashScreen />,
);
const PurchasedCampaignsPageComponent = asyncComponent(() =>
  import('../modules/campaign/PurchasedPage'),
  <SplashScreen />,
);

const CampaignDetailPageComponent = asyncComponent(() =>
  import('../modules/campaign/CampaignDetailPage'),
  <SplashScreen />,
);

const UserProfilePageComponent = asyncComponent(() =>
  import('../modules/userProfile/UserProfilePage'),
  <SplashScreen />,
);

const PrivateRouteWithBanners = withSalesPromotionBanners(PrivateRoute);
const PrivateRouteWithAccessWithBanners = withSalesPromotionBanners(PrivateRouteWithCampaignAccess);

type Props = {
  location: Object
};

function Routes({ location }: Props) {
  return (
    <Switch>
      <Route path="/login" component={LoginPageComponent} location={location} />
      {isDevFlagEnabled('FOLLO_WITHOUT_FOLLO') &&
      <Route path="/sign-up/with-:signUpWith/:reference" component={SignUpPage} location={location} />
      }
      {isDevFlagEnabled('FOLLO_WITHOUT_FOLLO') &&
      <Route path="/access/with-:signUpWith/:reference" component={AccessPage} location={location} />
      }
      <Route path="/reset-password" component={ResetPasswordPage} location={location} />
      <Route path="/forgot-password" component={ForgotPasswordPage} location={location} />
      <Route path="/accept-invitation" component={AcceptInvitationPageComponent} location={location} />
      <Route path="/proposition-printing" component={PropositionPrintingPage} location={location} />
      <Route path="/confirm-email" component={ConfirmEmailPage} location={location} />
      <Route path="/campaign-printing" component={CampaignPrintingPage} location={location} />
      <PrivateRouteWithBanners exact path="/user-profile" component={UserProfilePageComponent} location={location} />
      <PrivateRouteWithBanners path="/dashboard" component={DashboardPageComponent} location={location} />
      <PrivateRouteWithBanners exact path="/campaigns/proposed" component={ProposedCampaignsPageComponent} location={location} />
      <PrivateRouteWithBanners exact path="/campaigns/purchased" component={PurchasedCampaignsPageComponent} location={location} />
      <PrivateRouteWithBanners exact path="/tutorials" component={TutorialPage} location={location} />

      {isDevFlagEnabled('FOLLO_WITHOUT_FOLLO') &&
        <PrivateRouteWithAccessWithBanners exact path="/campaigns/proposed/:reference" component={PropositionDetailsPage} signUpWith="proposition" location={location} />
      }
      {!isDevFlagEnabled('FOLLO_WITHOUT_FOLLO') &&
        <PrivateRouteWithBanners exact path="/campaigns/proposed/:reference" component={PropositionDetailsPage} location={location} />
      }

      {isDevFlagEnabled('FOLLO_WITHOUT_FOLLO') &&
      <PrivateRouteWithAccessWithBanners exact path="/campaigns/purchased/:reference" component={CampaignDetailPageComponent} signUpWith="campaign" location={location} />
      }
      {!isDevFlagEnabled('FOLLO_WITHOUT_FOLLO') &&
        <PrivateRouteWithBanners exact path="/campaigns/purchased/:reference" component={CampaignDetailPageComponent} location={location} />
      }
      <Route path="/" component={DefaultRouteRedirect} />
    </Switch>
  );
}

export default Routes;



// WEBPACK FOOTER //
// ./src/advertisers/layout/Routes.js